import { FileAddIcon } from "@hugeicons-pro/core-stroke-rounded";
import { useQuery } from "@tanstack/react-query";
import { landlordSurveyApi } from "api/landlord-surveys/landlord-surveys";
import { useAuthContext } from "providers/Auth";
import { Layout } from "providers/Layout";
import { ScreeningTemplatesHeader } from "shared/app/ScreeningTemplatesHeader";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Loader } from "shared/components/Loader";
import { Redirect } from "shared/components/Redirect";
import { SurveyCard } from "./components/SurveyCard";
import { FEATURES } from "types/landlord/partner";
import { Link } from "react-router-dom";

export const LandlordSurveysView = () => {
  const { type, partner } = useAuthContext();

  const isAvailable =
    type.isBoomScreen &&
    partner?.features.includes(FEATURES.WIP_FEAT_PREMIUM_RENTAL_VERIFICATION);

  const landlordSurveysList = useQuery({
    queryFn: landlordSurveyApi.getSurveys,
    queryKey: ["LANDLORD_SURVEYS"],
    enabled: isAvailable
  });

  if (!isAvailable) return <Redirect href="/" />;

  if (landlordSurveysList.isLoading)
    return (
      <Layout
        headerClassName="pb-0 border-b border-alpha-40 pt-6"
        header={<ScreeningTemplatesHeader />}
      >
        <div className="mx-auto max-w-[1172px] w-full">
          <Link to="/landlord-surveys/add">
            <Button
              variant={ButtonVariant.PRIMARY}
              size={ButtonSize.SM}
              className="ml-auto mb-4"
              HugeIcon={FileAddIcon}
            >
              Create a survey
            </Button>
          </Link>
          <div className="flex gap-4 flew-wrap">
            <Loader />
          </div>
        </div>
      </Layout>
    );

  return (
    <Layout
      headerClassName="pb-0 border-b border-alpha-40 pt-6"
      header={<ScreeningTemplatesHeader />}
    >
      <div className="mx-auto max-w-[1172px] w-full">
        <Link to="/landlord-surveys/add">
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            className="ml-auto mb-4"
            HugeIcon={FileAddIcon}
          >
            Create a survey
          </Button>
        </Link>
        <div className="flex gap-4 flex-wrap w-full">
          {landlordSurveysList.data?.length
            ? landlordSurveysList.data.map((survey) => (
                <SurveyCard key={survey.id} {...survey} />
              ))
            : null}
        </div>
      </div>
    </Layout>
  );
};
